import React from "react";
import Index from "../_components/DataAccessAndReport/Index";

function DataAccessAndReportPage() {
    return <Index />
}

export default DataAccessAndReportPage;